import {
  DASHBOARD_DELETE_DATA,
  DASHBOARD_SET_STATE,
  DASHBOARD_SET_WORKSHEETS,
  DASHBOARD_UPDATE_DATA,
  DASHBOARD_UPDATE_WORKSHEETS_DATA
} from './types';

export const actions = {
  [DASHBOARD_UPDATE_DATA]: ({commit}, payload) => {
    commit(DASHBOARD_SET_STATE, payload);
  },

  [DASHBOARD_DELETE_DATA]: ({commit}) => {
    commit(DASHBOARD_SET_STATE, {
      category: {},
      columns: [],
      data: [],
      groups: [],
      id: '',
      measures: [],
      name: '',
      rows: [],
      title: '',
      type: '',
      worksheets: [],
      url: ''
    });
  },

  [DASHBOARD_UPDATE_WORKSHEETS_DATA]: ({commit}, payload) => {
    commit(DASHBOARD_SET_WORKSHEETS, payload);
  }
};
